module.exports = __webpack_public_path__ + "img/it_it.70c0eb88.svg";